import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2 } from 'lucide-react';

const ProductCard = ({ product }) => {
  return (
    <div className="card-hover flex flex-col bg-white rounded-2xl border border-gray-200 overflow-hidden hover:shadow-xl hover:border-brand-200 group">
      {/* Card Image */}
      <div className="h-48 overflow-hidden bg-gray-100 relative">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-60"></div>
        <h3 className="absolute bottom-4 left-4 text-white text-xl font-bold shadow-sm">
          {product.name}
        </h3>
      </div>

      {/* Card Body */}
      <div className="p-6 flex flex-col flex-grow">
        <p className="text-gray-600 mb-6 text-sm leading-relaxed min-h-[40px]">
          {product.shortDescription}
        </p>

        {/* Feature Highlights (Limit to 3) */}
        <div className="space-y-3 mb-8 flex-grow">
          {product.features.slice(0, 3).map((feature, idx) => (
            <div key={idx} className="flex items-start gap-2.5">
              <CheckCircle2 className="w-4 h-4 text-brand-500 mt-0.5 flex-shrink-0" />
              <span className="text-xs text-gray-700 font-medium">{feature}</span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <Link
          to={`/products/${product.id}`}
          className="btn-secondary inline-flex items-center justify-center w-full px-4 py-2.5 bg-gray-50 text-gray-900 text-sm font-semibold rounded-lg border border-gray-200 hover:bg-brand-600 hover:text-white hover:border-brand-600 group-hover:shadow-md"
        >
          Learn More
          <ArrowRight className="arrow-icon w-4 h-4 ml-2" />
        </Link>
      </div>
    </div>
  );
};

export default ProductCard;

